import { Dialog } from '@mui/material'
import JButton from '../buttons'
import OutlineButton from '../outlineButton'
import './actionInfoDialog.scss'
import CheckboxRadio from '../CheckboxRadio'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import CloseButton from '../closeButton'

const ActionInfoDialog = ({
  shouldOpen,
  mode,
  dir,
  data,
  closeButtonText,
  shouldCloseCallBack,
  actionText,
  handleCallBack,
  featuredIconSrc,
  classes,
  isCorporate,
  loading,
  title,
  termsAndCond = false,
  serviceName,
  servicePrice,
  serviceDescription,
  withCloseButton = false,
  withRedirectButton = false,
  redirectButtonText,
  redirectCallBack,
  closeCallBack,
  subServiceName,
}) => {
  const [translation] = useTranslation(['common'])
  const [isChecked, setIsChecked] = useState(true)
  const handleChange = () => {
    setIsChecked(!isChecked)
  }

  const runPrimaryAction = () => {
    if (typeof handleCallBack === 'function') handleCallBack()
  }

  const closeDialog = () => {
    if (typeof shouldCloseCallBack === 'function') shouldCloseCallBack()
    else if (typeof closeCallBack === 'function') closeCallBack()
  }

  return (
    <Dialog
      open={shouldOpen}
      className={`action-info-dialog-container ${
        isCorporate ? '' : `action-info-dialog-container-${mode}`
      } action-info-dialog-container-${dir} ${classes}`}
      >
      {(title || featuredIconSrc) && (
        <div
          className={`action-info-dialog-body-title ${
            isCorporate ? 'corporate-action-info-dialog-body-title' : ''
          }`}>
          {featuredIconSrc ? (
            <img
              src={featuredIconSrc}
              alt="dialog-featured-icon"
              className="action-info-dialog-featured-icon"
            />
          ) : null}
          {title}
          {withCloseButton && (
            <div className="action-info-dialog-close-button">
              <CloseButton onClick={closeCallBack} />
            </div>
          )}
          
        </div>
      )}
      <div className="action-info-dialog-body" style={{ paddingTop: !title ? '24px' : '' }}>
        <p>
          {data}

          <span className="service-name"> {serviceName} </span>
          <span className="service-description"> {serviceDescription} </span>
          <span className="service-description"> {subServiceName} </span>
          {servicePrice ? (
            servicePrice !== 0 ? (
              <span>
                {' '}
                {translation('with-price')}{' '}
                <span className="service-price">
                  {servicePrice} {translation('unit')}
                  {translation('question-mark')}
                </span>
              </span>
            ) : servicePrice === 0 ? (
              <span>
                {' '}
                {translation('free')}
                {translation('question-mark')}
              </span>
            ) : (
              ''
            )
          ) : null}
          {servicePrice
            ? servicePrice == 0
              ? translation('question-mark')
              : null
            : null}
        </p>
      </div>
      <div className="terms-and-conditions-container">
        {termsAndCond ? (
          <CheckboxRadio
            mode={mode}
            checked={isChecked}
            onChange={handleChange}
            label={`${translation('iAgreeToThe')}`}
            subLabel={`${translation('termsAndCond')}`}
          />
        ) : null}
      </div>
      <div className="action-info-dialog-buttons-container">
        {/* if withRedirectButton is true, i will show the redirect button the same style as the close button */}
        {withRedirectButton && (
            <JButton
            label={redirectButtonText}
            height="56"
            size="196"
            color="main"
            isCorporate={isCorporate}
            type="submit"
            loading={loading}
            disabled={!isChecked}
            onClick={() => redirectCallBack()}
          />
          )}
        {/* if withRedirectButton is true, i will show the action button the same style as outline button */}
        {withRedirectButton && actionText ? (
          <OutlineButton
            label={actionText}
            color="main"
            borderColor="blue"
            backgroundColor="white"
            textColor="blue"
            width="196"
            font="roman"
            classes="m-8"
            disabled={loading}
            onClick={() => handleCallBack()}
          />
        ) : (
          <JButton
            label={actionText}
            height="56"
            size="196"
            color="main"
            isCorporate={isCorporate}
            type="submit"
            loading={loading}
            disabled={!isChecked}
            onClick={runPrimaryAction}
          />
        )}
        {closeButtonText && (
          <OutlineButton
            label={closeButtonText}
            color={isCorporate ? 'corporate' : 'main'}
            width="196"
            font="roman"
            classes="m-8"
            disabled={loading}
            onClick={closeDialog}
            isCorporate={isCorporate}
          />
        )}
      </div>
    </Dialog>
  )
}
export default ActionInfoDialog
